import { roundHalfUp } from '@sit/core';
/**
 * Computes display-rounded totals using per-row rounding to match displayed row values.
 * Groups entries by row, rounds each row's hours to 2 decimals, then sums.
 * Only considers top-level entries (parentId == null).
 * Returns totals in display hours (already rounded, NOT seconds).
 */
export function computePerRowRoundedTotals(entries) {
    const rowMap = new Map();
    for (const entry of entries.filter((e) => e.parentId == null)) {
        const duration = Number(entry.duration) || 0;
        const existing = rowMap.get(entry.timesheetRowId) ?? {
            total: 0,
            billable: 0,
        };
        existing.total += duration;
        if (entry.billable) {
            existing.billable += duration;
        }
        rowMap.set(entry.timesheetRowId, existing);
    }
    let totalHours = 0;
    let billableHours = 0;
    for (const row of rowMap.values()) {
        const rowTotalHours = roundHalfUp(row.total / 3600, 2);
        const roundedBillableHours = roundHalfUp(row.billable / 3600, 2);
        // Cap billable to row total after rounding. Math.min handles positive rows;
        // Math.max handles negative rows (Math.min would wrongly assign non-billable
        // negative hours to billable when rounded billable is 0).
        const rowBillableHours = rowTotalHours < 0
            ? Math.max(roundedBillableHours, rowTotalHours)
            : Math.min(roundedBillableHours, rowTotalHours);
        totalHours += rowTotalHours;
        billableHours += rowBillableHours;
    }
    return {
        totalHours,
        billableHours,
        nonBillableHours: totalHours - billableHours,
    };
}
//# sourceMappingURL=timesheet-totals.js.map